module.exports = __webpack_public_path__ + "img/3.6e0246e0.png";